import request from '@/utils/request'

// 用户身份
export function getSourceOptions(params) {
  return request({
    url: '/admin/v1/dic/config/userIdentity/list',
    method: 'get',
    params
  })
}
// 反馈方式
export function getChannelOptions(params) {
  return request({
    url: '/admin/v1/dic/config/feedbackChannel/list',
    method: 'get',
    params
  })
}
// 模板类型列表
export function getTemplateTypeOptions(params) {
  return request({
    url: '/admin/v1/dic/config/templateType/list',
    method: 'get',
    params
  })
}
// 工单判责类型列表
export function getJudgeTypeOptions(params) {
  return request({
    url: '/admin/v1/dic/config/judgeType/list',
    method: 'get',
    params
  })
}
